const { ExpressionBlock, nextCacheToken } = require('./expression-block');
const { FsDataProvider } = require('../core/data-provider');
const { assertTyped, typeOf, valueOf, makeValue, typedNull } = require('../core/value');
const { FSDataType } = require('../core/fstypes');
const { ArrayFsList } = require('../model/fs-list');

class SelectorProvider extends FsDataProvider {
  constructor(parent) {
    super(parent);
    this.sourceValue = typedNull();
    this.sourceCollection = null;
    this.__fsSelectorProvider = true;
  }

  setSource(value) {
    const typed = assertTyped(value);
    this.sourceValue = typed;
    if (typeOf(typed) === FSDataType.KeyValueCollection) {
      this.sourceCollection = valueOf(typed);
    } else {
      this.sourceCollection = null;
    }
  }

  get(name) {
    const lower = name.toLowerCase();
    if (this.sourceCollection && this.sourceCollection.isDefined(lower)) {
      return this.sourceCollection.get(lower);
    }
    return super.get(name);
  }

  isDefined(name, hierarchy = true) {
    const lower = name.toLowerCase();
    if (this.sourceCollection && this.sourceCollection.isDefined(lower, false)) {
      return true;
    }
    return super.isDefined(name, hierarchy);
  }
}

class SelectorExpression extends ExpressionBlock {
  constructor() {
    super();
    this.Source = null;
    this.Selector = null;
  }

  evaluateInternal(provider) {
    const sourceTyped = assertTyped(this.Source.evaluate(provider));
    const sourceType = typeOf(sourceTyped);

    if (sourceType === FSDataType.List) {
      const list = valueOf(sourceTyped);
      const results = [];
      for (let i = 0; i < list.length; i += 1) {
        const item = list.get(i) ?? typedNull();
        const selectorProvider = new SelectorProvider(provider);
        selectorProvider.__fsCacheToken = nextCacheToken();
        selectorProvider.setSource(item);
        const result = assertTyped(this.Selector.evaluate(selectorProvider));
        results.push(result);
      }
      return makeValue(FSDataType.List, new ArrayFsList(results));
    }

    const selectorProvider = new SelectorProvider(provider);
    selectorProvider.__fsCacheToken = nextCacheToken();
    selectorProvider.setSource(sourceTyped);
    return assertTyped(this.Selector.evaluate(selectorProvider));
  }

  getChilds() {
    return [this.Source, this.Selector];
  }

  asExpressionString(provider) {
    return `${this.Source.asExpressionString(provider)} ${this.Selector.asExpressionString(provider)}`;
  }
}

module.exports = {
  SelectorExpression
};
